import React from 'react';
import PropTypes from 'prop-types';
import {
  CardContent,
  Card,
  Divider,
  Typography,
  CardHeader,
  Stack,
} from '@mui/material';
import {
  Timeline,
  TimelineDot,
  TimelineItem,
  TimelineContent,
  TimelineSeparator,
  TimelineConnector,
} from '@mui/lab';
import { fDateTime } from '../../../utils/formatTime';

AppOrderTimeline.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  list: PropTypes.array.isRequired,
};

export default function AppOrderTimeline({ title, subheader, list, ...other }) {
  const sortedList = list.slice().sort((a, b) => Date.parse(b.time) - Date.parse(a.time));
  const displayedList = sortedList.slice(0, 5);

  return (
    <Card {...other} sx={{height:'495px'}}>
      <CardHeader title={title} subheader={subheader} />
      <CardContent
        sx={{
          '& .MuiTimelineItem-missingOppositeContent:before': {
            display: 'none',
          },
          p: 2,
        }}
      >
        <Timeline>
          <Stack spacing={1.5} sx={{ pr: 0 }}>
            {displayedList.map((item, index) => (
              <OrderItem key={item.id} item={item} isLast={index === displayedList.length - 1} />
            ))}
          </Stack>
        </Timeline>
      </CardContent>
      {/* <Divider /> */}
    </Card>
  );
}

OrderItem.propTypes = {
  isLast: PropTypes.bool,
  item: PropTypes.shape({
    time: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    title: PropTypes.string,
  }),
};

function OrderItem({ item, isLast }) {
  const { title, time } = item;

  // Infer dot color based on title content
  const getColor = () => {
    const lower = title.toLowerCase();
    if (lower.includes('delete')) return 'error';
    if (lower.includes('add')) return 'success';
    if (lower.includes('update')) return 'info';
    if (lower.includes('warning')) return 'warning';
    return 'primary';
  };

  return (
    <TimelineItem>
      <TimelineSeparator>
        <TimelineDot color={getColor()} />
        {!isLast && <TimelineConnector />}
      </TimelineSeparator>

      <TimelineContent>
        <Typography variant="subtitle2">{title}</Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          {fDateTime(time)}
        </Typography>
      </TimelineContent>
    </TimelineItem>
  );
}
